import { Box, Container, Typography } from "@material-ui/core";
import React, { useContext, useEffect } from "react";
import { setAnalyticsData } from "../utils/firebaseLog";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useBackButtonRedirect from "../hooks/useBackButton";
import SectionHeader from "../components/SectionHeader";
import { UserDataContext } from "../context/UserDataContext";

export default function BuyComplete({ email }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { state } = useLocation();
  const { fetchUserData, setUserData, getCouponData, setCouponData } =
    useContext(UserDataContext);
  const buyType = searchParams.get("type") ? searchParams.get("type") : null;
  const navigate = useNavigate();
  useBackButtonRedirect();
  if (!buyType) {
    navigate("/error?code=404");
    return null;
  }
  useEffect(() => {
    setUserData(null);
    if (state && state.couponCode) {
      let newCouponData = getCouponData.couponList.filter((code) => {
        return code.couponCode != state.couponCode;
      });
      let obj = {
        couponList: newCouponData,
      };
      console.log(obj);
      setCouponData(obj);
      fetchUserData(false);
    } else {
      fetchUserData();
    }

    document.title = "決済完了 | じぶん専用IT相談室";
  }, []);

  const data = {
    INTERVIEW: {
      title: "ご購入ありがとうございました。",
      description:
        "問診専用の電話番号をメール送信しました。\n メールをご確認ください。\nご登録済みのメールアドレス宛にご利用明細をお送りいたします。\n お支払い情報は、お支払い履歴からご確認いただけます。\n 処理完了に少し時間がかかる場合があります。ご了承ください。\n メールは「noreply@jibun-it.jp」からお送りします。\n メールが届かない場合は、迷惑メールフォルダに分類されていないか \n ご確認お願いします。",
    },
    SUPPORT: {
      title: "ご予約ありがとうございました。",
      description:
        "ご登録済みのメールアドレス宛にご利用明細をお送りいたします。\nお支払い情報は、お支払い履歴からご確認いただけます。\n 処理完了に少し時間がかかる場合があります。ご了承ください。 \nメールは「noreply@jibun-it.jp」からお送りします。 \nメールが届かない場合は、迷惑メールフォルダに分類されていないか \nご確認お願いします。",
    },
    ADD: {
      title: "ご購入ありがとうございました。",
      description:
        "ご登録済みのメールアドレス宛にご利用明細をお送りいたします。\nお支払い情報は、お支払い履歴からご確認いただけます。\n処理完了に少し時間がかかる場合があります。ご了承ください。\nメールは「noreply@jibun-it.jp」からお送りします。\nメールが届かない場合は、迷惑メールフォルダに分類されていないか\nご確認お願いします。",
    },
    TIP: {
      title: "ありがとうございました。",
      description:
        "評価のご協力、ありがとうございます。\n大切なご意見を今後の業務改善、サービス向上に活かしてまいります。\n\nまた、チップ還元についてもありがとうございます。\n大変励みになります。\n\nご登録済みのメールアドレス宛にご利用明細をお送りいたします。\nお支払い情報は、お支払い履歴からご確認いただけます。\n\n処理完了に少し時間がかかる場合があります。ご了承ください。\n\nメールは「noreply@jibun-it.jp」からお送りします。\nメールが届かない場合は、迷惑メールフォルダに分類されていないか\nご確認お願いします。",
    },
  };
  if (data[buyType] == undefined) {
    navigate("/error?code=404");
    return null;
  }
  const replaceNewlinesWithBreaks = (text) => {
    const lines = text.split("\n");
    return lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };
  const replaceNewlinesWithParas = (text) => {
    const lines = text.split("\n");
    return lines.map((line, index) => (
      <Typography key={index} className="text-center mobile-text-left">
        {line}
      </Typography>
    ));
  };
  return (
    <Box component={"section"} className="section bg-dots">
      <Container className="container">
        <SectionHeader
          currentPage={buyType && data[buyType].title}
          preHeading={"Payment Successfull"}
        />
        {buyType && replaceNewlinesWithParas(data[buyType].description)}
      </Container>
      <Box component={"section"} className="section text-center">
        <button className="classification-btn" onClick={() => navigate("/")}>
          ホームへ
        </button>
      </Box>
    </Box>
  );
}
